export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Payments.json?hash=559575fe9353ae1bd8efc6959b843c5d";